import { useState } from "react";
import { useLang } from "../LangContext";

export default function BottomNav({ tab, setTab, role, urgentCnt, unreadNotifs }) {
  const [showMore, setShowMore] = useState(false);
  const { t } = useLang();

  const NAV_TABS = {
    architect: [
      { id: "dashboard", label: t("home"), icon: "🏠" },
      { id: "materials", label: t("materials"), icon: "🧱" },
      { id: "todos", label: t("actions"), icon: "✓" },
      { id: "journal", label: t("journal"), icon: "💬" },
      { id: "more", label: t("more"), icon: "⋯" },
    ],
    contractor: [
      { id: "dashboard", label: t("home"), icon: "🏠" },
      { id: "mon-chantier", label: t("myProject"), icon: "⚒" },
      { id: "todos", label: t("actions"), icon: "✓" },
      { id: "journal", label: t("journal"), icon: "💬" },
      { id: "more", label: t("more"), icon: "⋯" },
    ],
    client: [
      { id: "dashboard", label: t("home"), icon: "🏠" },
      { id: "todos", label: t("decisions"), icon: "✓" },
      { id: "journal", label: t("journal"), icon: "💬" },
      { id: "inspiration", label: t("inspiration"), icon: "📌" },
      { id: "more", label: t("more"), icon: "⋯" },
    ],
  };

  const MORE_TABS = {
    architect: [
      { id: "budget", label: t("budget"), icon: "💶" },
      { id: "funnel", label: t("progress"), icon: "📊" },
      { id: "gantt", label: "Planning", icon: "📅" },
      { id: "equipe", label: t("team"), icon: "👷" },
      { id: "acces", label: t("clientAccess"), icon: "🔑" },
    ],
    contractor: [
      { id: "budget", label: t("budget"), icon: "💶" },
      { id: "funnel", label: t("progress"), icon: "📊" },
      { id: "gantt", label: "Planning", icon: "📅" },
      { id: "equipe", label: t("team"), icon: "👷" },
      { id: "acces", label: t("clientAccess"), icon: "🔑" },
    ],
    client: [
      { id: "budget", label: t("budget"), icon: "💶" },
      { id: "funnel", label: t("progress"), icon: "📊" },
      { id: "gantt", label: "Planning", icon: "📅" },
    ],
  };

  const tabs = NAV_TABS[role] || NAV_TABS.architect;
  const moreTabs = MORE_TABS[role] || [];
  const isMoreActive = moreTabs.some(t => t.id === tab);

  const handleTab = (id) => {
    if (id === "more") { setShowMore(true); return; }
    setTab(id);
  };

  return (
    <>
      <div className="bottom-nav">
        <div className="bottom-nav-inner">
          {tabs.map(tab_ => {
            const isCurrent = tab_.id === "more" ? isMoreActive : tab === tab_.id;
            const badge = tab_.id === "todos" && urgentCnt > 0 ? urgentCnt : tab_.id === "journal" && unreadNotifs > 0 ? unreadNotifs : null;
            return (
              <button key={tab_.id} className={`bnav-item${isCurrent ? " active" : ""}`} onClick={() => handleTab(tab_.id)}>
                {badge && <span className="bnav-badge">{badge}</span>}
                <span className="bnav-icon">{tab_.icon}</span>
                <span className="bnav-label">{tab_.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      {showMore && (
        <div className="modal-overlay" onClick={() => setShowMore(false)}>
          <div className="sheet" onClick={e => e.stopPropagation()} style={{ maxWidth: 400 }}>
            <div style={{ padding: "16px 20px", borderBottom: "1px solid #2A2924", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontFamily: "'DM Serif Display',serif", fontSize: 17, color: "#E8E2D8" }}>{t("navigation")}</span>
              <button className="btn" onClick={() => setShowMore(false)} style={{ fontSize: 18, color: "#5A5450" }}>✕</button>
            </div>
            <div style={{ padding: "12px 12px 24px" }}>
              {moreTabs.map(mt => (
                <button key={mt.id} className="btn" onClick={() => { setTab(mt.id); setShowMore(false); }}
                  style={{ width: "100%", display: "flex", alignItems: "center", gap: 14, padding: "14px 12px", borderRadius: 10, background: tab === mt.id ? "#C9A96E15" : "transparent", border: "none", color: tab === mt.id ? "#C9A96E" : "#E8E2D8", fontSize: 14, fontWeight: tab === mt.id ? 600 : 400, marginBottom: 2 }}>
                  <span style={{ fontSize: 20, width: 28, textAlign: "center" }}>{mt.icon}</span>
                  {mt.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
